import type { Dispatch, SetStateAction } from "react";

import { Select } from "@king-ict/eupisi-ui/components";
import { codeBookToSelectData, nameof } from "@king-ict/eupisi-ui/utils";
import { useTranslation } from "react-i18next";

import { useAuth, useAuthCounties, useInput } from "../../../hooks";

import { REQUEST_COUNTY_FILTER_ACCESS } from "../constants";

type FilterStateWithCounty = { countyId?: number };

type RequestCountyFilterSelectProps<T extends FilterStateWithCounty> = {
  value: number | undefined;
  setFilterState: Dispatch<SetStateAction<T>>;
};

export const RequestCountyFilterSelect = <T extends FilterStateWithCounty>({
  value,
  setFilterState,
}: RequestCountyFilterSelectProps<T>) => {
  const { t } = useTranslation();
  const { handleChange } = useInput();
  const auth = useAuth();
  const authCounties = useAuthCounties();

  if (!auth.hasRoleAccess(REQUEST_COUNTY_FILTER_ACCESS)) {
    return null;
  }

  return (
    <Select
      label={t("common.institutionDetails.countyName")}
      name={nameof<FilterStateWithCounty>("countyId")}
      value={value}
      onChange={handleChange(setFilterState)}
      selectData={codeBookToSelectData(authCounties)}
      emptyOption={{ text: t("common.all"), value: undefined }}
    />
  );
};
